import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
// import { take } from 'rxjs/operators';
import * as _ from 'lodash';

import { MessageComponent } from '../shared/component/message/message.component';

import { ReturnMessageModel } from '../shared/model/return-message.model';
import { InspectionPlanModel } from '../shared/model/inspection-plan.model';
import { InspectionPlanService } from '../shared/service/inspection-plan.service';
import { ListValueModalComponent } from '../shared/component/list-value-modal/list-value-modal.component';

@Component({
  styles: [''],
  selector: 'app-inspection-plan',
  templateUrl: './inspection-plan.component.html',
})
export class InspectionPlanComponent implements OnInit {
  @ViewChild(MessageComponent) message: MessageComponent;
  @ViewChild(ListValueModalComponent) modal: ListValueModalComponent;

  lastEvent: any;
  totalRecords: number;

  listOptions: any[] = [];
  lists: InspectionPlanModel[] = [];
  list: InspectionPlanModel = new InspectionPlanModel();
  listAndFields: InspectionPlanModel = new InspectionPlanModel();

  selectedField: any = {};

  selectedMethod = '';
  selectedOrdenation = '';

  ascDesc = [];
  ordenation = [];

  errors = [[],[]];

  constructor(private translateService: TranslateService, private listService: InspectionPlanService) {}

  ngOnInit() {}

  lazy(e) {
    this.lastEvent = e;

    this.listService.getPaginated({ init: e.first, end: e.rows })
    .subscribe((lists) => {
      if (lists) {
        const { rows, count } = lists;

        this.totalRecords = count as number;
        this.lists = rows as InspectionPlanModel[];

        if (rows && rows.length) {
          this.listOptions = rows.map(({ name: label, id: value }) => { return { label, value }})
        }
      } else return this.message.error(this.translate('error'))

      this.loadOrdenation();
    });
  }

  onSelectField(e) {
    this.selectedField = e.data;
  }

  onSelectList(e) {
    this.list = e.data as InspectionPlanModel;

    this.onNewItem();
  }

  onSaveList() {
    this.listService.saveList(this.list).subscribe((r: ReturnMessageModel) => {
      this._responseErrorHandler(r);

      this.lazy(this.lastEvent);
      this.onNewList();
    });
  }

  onSaveItem() {
    this.listService.saveItem(this.selectedField).subscribe((r: ReturnMessageModel) => {
      this._responseErrorHandler(r);

      this.lazy(this.lastEvent);
      this.onNewItem();
    });
  }

  onNewList() {
    this.list = new InspectionPlanModel();
  }

  onNewItem() {
    this.selectedField = {} as any;
    this.selectedField.inspection_plan_id = this.list.id;
  }

  onDeleteList() {
    this.listService.deleteList(this.list.id + '').subscribe((r: ReturnMessageModel) => {
      this._responseErrorHandler(r);

      this.lazy(this.lastEvent);
      this.onNewList();
    });
  }

  onDeleteItem() {
    this.listService.deleteItem(this.selectedField.id + '').subscribe((r: ReturnMessageModel) => {
      this._responseErrorHandler(r);

      this.lazy(this.lastEvent);
      this.onNewList();
    });
  }

  // Auxiliar Functions

  _responseErrorHandler(r: ReturnMessageModel) {
    if (r.error) this.message.error(r.message);
    else this.message.success(r.message);
  }

  validate(id: number = null): boolean {
    this.errors[0] = []; // list (ipm)
    this.errors[1] = []; // field (ipim)

    if (!this.list.name) {
      this.errors[0].push('invalid_name');
    }

    if (!this.selectedField.description) {
      this.errors[1].push('invalid_description');
    }

    if (this.selectedField.to < this.selectedField.from) {
      this.errors[1].push('until_need_be_bigger_than_from');
    }

    if (this.selectedField.from > this.selectedField.to) {
      this.errors[1].push('from_need_be_small_than_until');
    }

    if (!this.selectedField.quantity && !this.selectedField.percentage) {
      this.errors[1].push('quantity_or_percentage_required');
    }

    if (this.selectedField.quantity && this.selectedField.percentage) {
      this.errors[1].push('quantity_and_percentage_not_allowed');
    }

    if (id != null) return !this.errors[id].length;
    return !this.errors[0].length && !this.errors[1].length;
  }

  duplicateValidation() {
    return !this.list.id && this.lists.findIndex((list) => list.name == this.list.name) > -1;
  }

  order() {
		this.lists = _.orderBy(this.lists, this.selectedOrdenation, this.selectedMethod);
  }

  translate = (key: string) => this.translateService.instant(key || "invalid");

  loadOrdenation() {
      this.ascDesc = [
      { value: 'asc', label: this.translate('asc') },
      { value: 'desc', label: this.translate('desc') },
    ];

    this.ordenation = [
      { value: 'created_at', label: this.translate('creation_date') },
      { value: 'name', label: this.translate('alph_order') },
      { value: 'list_type', label: this.translate('type') }
    ];
  }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/inspection-plan/inspection-plan.component.ts